<script setup lang="ts">
import { computed } from 'vue'
import { Separator } from '@/components/shadcn'

type StyleType = 'default' | 'primary' | 'secondary' | 'muted' | 'sm' | 'lg'

const props = withDefaults(
  defineProps<{
    /** 구분선 방향 */
    orientation?: 'horizontal' | 'vertical'
    /** 구분선 스타일 테마 */
    styletype?: StyleType
    /** 추가 CSS 클래스 */
    class?: string
  }>(),
  {
    orientation: 'horizontal',
    styletype: 'default',
  },
)

const STYLE_PRESETS: Record<StyleType, { class?: string }> = {
  default: { class: 'bg-border' },
  primary: { class: 'bg-primary' },
  secondary: { class: 'bg-secondary' },
  muted: { class: 'bg-muted' },
  sm: { class: 'h-px' },
  lg: { class: 'h-0.5' },
}

const mapped = computed(() => {
  const styleKey = props.styletype || 'default'
  const preset = STYLE_PRESETS[styleKey] ?? STYLE_PRESETS.default
  const finalClass = [preset?.class, props.class].filter(Boolean).join(' ')

  return {
    orientation: props.orientation,
    class: finalClass,
  }
})
</script>

<template>
  <Separator v-bind="mapped" />
</template>
